__turbopack_context__.v({
  "breedOption": "collapsibleSearchHeader-module-scss-module__nPRn8G__breedOption",
  "breedOptionPhoto": "collapsibleSearchHeader-module-scss-module__nPRn8G__breedOptionPhoto",
  "breedOptionPhotoPlaceholder": "collapsibleSearchHeader-module-scss-module__nPRn8G__breedOptionPhotoPlaceholder",
  "collapseButton": "collapsibleSearchHeader-module-scss-module__nPRn8G__collapseButton",
  "compactBar": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactBar",
  "compactBarCenter": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactBarCenter",
  "compactBarLeft": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactBarLeft",
  "compactBarRight": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactBarRight",
  "compactButton": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactButton",
  "compactButtonIcon": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactButtonIcon",
  "compactButtonIconImage": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactButtonIconImage",
  "compactButtonLabel": "collapsibleSearchHeader-module-scss-module__nPRn8G__compactButtonLabel",
  "expandedHeader": "collapsibleSearchHeader-module-scss-module__nPRn8G__expandedHeader",
  "expandedPanel": "collapsibleSearchHeader-module-scss-module__nPRn8G__expandedPanel",
  "expandedTitle": "collapsibleSearchHeader-module-scss-module__nPRn8G__expandedTitle",
  "fieldBlock": "collapsibleSearchHeader-module-scss-module__nPRn8G__fieldBlock",
  "fieldLabel": "collapsibleSearchHeader-module-scss-module__nPRn8G__fieldLabel",
  "header": "collapsibleSearchHeader-module-scss-module__nPRn8G__header",
  "headerExpanded": "collapsibleSearchHeader-module-scss-module__nPRn8G__headerExpanded",
  "logoContainer": "collapsibleSearchHeader-module-scss-module__nPRn8G__logoContainer",
  "logoLink": "collapsibleSearchHeader-module-scss-module__nPRn8G__logoLink",
  "logoMark": "collapsibleSearchHeader-module-scss-module__nPRn8G__logoMark",
  "menuAvatar": "collapsibleSearchHeader-module-scss-module__nPRn8G__menuAvatar",
  "menuAvatarInitials": "collapsibleSearchHeader-module-scss-module__nPRn8G__menuAvatarInitials",
  "menuButton": "collapsibleSearchHeader-module-scss-module__nPRn8G__menuButton",
  "panelShell": "collapsibleSearchHeader-module-scss-module__nPRn8G__panelShell",
  "pawIcon": "collapsibleSearchHeader-module-scss-module__nPRn8G__pawIcon",
  "searchIcon": "collapsibleSearchHeader-module-scss-module__nPRn8G__searchIcon",
  "selectControl": "collapsibleSearchHeader-module-scss-module__nPRn8G__selectControl",
  "selectGrid": "collapsibleSearchHeader-module-scss-module__nPRn8G__selectGrid",
  "selectItem": "collapsibleSearchHeader-module-scss-module__nPRn8G__selectItem",
  "srOnly": "collapsibleSearchHeader-module-scss-module__nPRn8G__srOnly",
});
